// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { createEnum } from "@cartographerio/util";

import { MapPermissionModel } from "../types.generated";

const RoleBased: MapPermissionModel = "RoleBased";
const Workspace: MapPermissionModel = "Workspace";
const Active: MapPermissionModel = "Active";
const Public: MapPermissionModel = "Public";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MapPermissionModelEnum = {
  ...createEnum("MapPermissionModel", [
    [RoleBased, "Only users with explicit permission can access this map"],
    [Workspace, "Everyone in the workspace can access this map"],
    [Active, "Anyone who is logged into Cartographer can access this map"],
    [Public, "Anyone can access this map, whether logged in or not"],
  ]),
  RoleBased,
  Workspace,
  Active,
  Public,
};

export default MapPermissionModelEnum;
